// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-rental-packages-js": () => import("./../../../src/pages/rental-packages.js" /* webpackChunkName: "component---src-pages-rental-packages-js" */),
  "component---src-pages-why-go-bottlefree-js": () => import("./../../../src/pages/why-go-bottlefree.js" /* webpackChunkName: "component---src-pages-why-go-bottlefree-js" */),
  "component---src-templates-basic-js": () => import("./../../../src/templates/basic.js" /* webpackChunkName: "component---src-templates-basic-js" */),
  "component---src-templates-contact-js": () => import("./../../../src/templates/contact.js" /* webpackChunkName: "component---src-templates-contact-js" */)
}

